import { useEffect, useState } from 'react';
import api from '../services/api';
import VehicleCard from '../components/VehicleCard';
import BackButton from '../components/BackButton';
import { WHATSAPP_LINKS, CONNECT_INFO } from '../constants/connect';
import usePageMeta from '../hooks/usePageMeta';
import './Pages.css';

export default function Locadora() {
  usePageMeta({
    title: 'Estoque de Locadora (abaixo da FIPE) - Connect Veiculos Osasco',
    description:
      'Escolha seu carro com desconto real, veja presencialmente no patio da locadora e finalize com a Connect Veiculos em Osasco.',
  });

  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    api
      .get('/vehicles')
      .then((res) => {
        if (mounted) {
          setVehicles(Array.isArray(res.data) ? res.data : []);
        }
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, []);

  const locadoraVehicles = vehicles.filter((vehicle) => {
    const type = (vehicle.inventoryType || '').toLowerCase();
    return type === 'locadora';
  });

  const steps = [
    {
      title: 'Briefing na Connect',
      description: CONNECT_INFO.address,
    },
    {
      title: 'Visita ao patio',
      description: 'Comparamos as unidades disponiveis e validamos historico e condicao.',
    },
    {
      title: 'Entrega com laudo',
      description: 'Acompanhamos ate documentacao e laudo cautelar aprovado.',
    },
  ];

  const faqs = [
    {
      question: 'Posso ver varios carros?',
      answer: 'Sim, organizamos a agenda para voce analisar diferentes opcoes no mesmo dia.',
    },
    {
      question: 'Por que sai abaixo da FIPE?',
      answer: 'Sao unidades de frota em renovacao: alto volume e desmobilizacao favorecem descontos reais.',
    },
    {
      question: 'Garantia?',
      answer: 'Aplicamos a politica da locadora e permanecemos ao seu lado em todo o processo.',
    },
  ];

  return (
    <div className="page-shell locadora-page">
      <BackButton />

      <section className="page-hero" aria-labelledby="locadora-title">
        <div className="page-hero__content">
          <h1 id="locadora-title">Estoque de Locadora - abaixo da FIPE</h1>
          <p>
            Ao lado das locadoras parceiras, encontramos oportunidades com desconto real e acompanhamos
            voce em todo o processo: briefing executivo na Connect, visita guiada ao patio e entrega com
            laudo aprovado.
          </p>
          <div className="page-hero__actions">
            <a
              className="page-button page-button--primary"
              href={WHATSAPP_LINKS.locadora}
              target="_blank"
              rel="noreferrer"
            >
              Agendar visita
            </a>
          </div>
        </div>
      </section>

      <section className="section-card" aria-labelledby="locadora-steps">
        <h2 id="locadora-steps">Como funciona</h2>
        <p className="section-helper">
          Mantemos o relacionamento e toda a verificacao tecnica enquanto voce aproveita o mix renovado das
          locadoras parceiras.
        </p>
        <div className="steps-list">
          {steps.map((step) => (
            <div key={step.title} className="step-item">
              <strong>{step.title}</strong>
              <p>{step.description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="section-card" aria-labelledby="locadora-faq">
        <h2 id="locadora-faq">Duvidas frequentes</h2>
        <div className="faq-list">
          {faqs.map((faq) => (
            <article key={faq.question} className="faq-item">
              <h3>{faq.question}</h3>
              <p>{faq.answer}</p>
            </article>
          ))}
        </div>
        <div className="page-hero__actions faq-cta">
          <a
            className="page-button page-button--primary"
            href={WHATSAPP_LINKS.locadora}
            target="_blank"
            rel="noreferrer"
            aria-label="Agendar visita pelo WhatsApp"
          >
            Agendar visita
          </a>
        </div>
      </section>

      <section className="section-card" aria-labelledby="locadora-estoque">
        <h2 id="locadora-estoque">Carros disponiveis nas locadoras parceiras</h2>
        {loading && <p>Carregando oportunidades...</p>}
        {!loading && locadoraVehicles.length === 0 && (
          <p>Nenhum carro de locadora foi cadastrado ainda. Fale conosco para receber as novas entradas assim que liberadas.</p>
        )}
        {!loading && locadoraVehicles.length > 0 && (
          <div className="grid">
            {locadoraVehicles.map((vehicle) => (
              <VehicleCard key={vehicle.id} vehicle={vehicle} />
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
